import { useCallback, useEffect, useState } from 'react';

export default function useInstallPrompt() {
  const [prompt, setPrompt] = useState(() => window.deferredInstallPrompt || null);
  const [installed, setInstalled] = useState(
    () => window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true
  );

  useEffect(() => {
    const available = (event) => {
      event?.preventDefault?.();
      setPrompt(window.deferredInstallPrompt || event || null);
    };
    const didInstall = () => {
      window.deferredInstallPrompt = null;
      setPrompt(null);
      setInstalled(true);
    };
    window.addEventListener('beforeinstallprompt', available);
    window.addEventListener('pwa-install-available', available);
    window.addEventListener('appinstalled', didInstall);
    return () => {
      window.removeEventListener('beforeinstallprompt', available);
      window.removeEventListener('pwa-install-available', available);
      window.removeEventListener('appinstalled', didInstall);
    };
  }, []);

  const promptInstall = useCallback(async () => {
    const event = prompt || window.deferredInstallPrompt;
    if (!event) return null;
    await event.prompt();
    const choice = await event.userChoice;
    window.deferredInstallPrompt = null;
    setPrompt(null);
    return choice.outcome;
  }, [prompt]);

  return { canInstall: Boolean(prompt) && !installed, installed, promptInstall };
}
